import React, { useEffect, useState } from "react";
import { BackButton, ClearFilterButton, EditButton, FilterButton } from "../../../../Components/Utils/Buttons";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import { GetAccess } from "../../../../Components/Utils/roles";
import Breadcrumb from "../../../../Components/Utils/Breadcrumb";

const ContractLayout = ({
  getData = () => {},
  setSearchQuery = () => {},
  EditAccess = false,
  ImportAccess = false,
  setOpen = () => {},
  setOpenExport = () => {},
  children,
  onCreateClick,
  searchValue = "",
  searchFun = () => {},
  isFilter = false,
  setFilterOpen = () => {},
  newfilter = false,
  ClearFilter = () => {},
  neededSearch = false,
  showproject = true,
  isCard = true,
  setViewMode = () => {},
  viewMode = "",
  ExportAccess = false,
}) => {
  const location = useLocation();
  const data = location.state?.data;
  const pageIndex = location.state?.pageIndex;
  const searchQuery = location.state?.searchQuery;
  const [percentOpen, setPercentOpen] = useState(false);

  let { pathname } = useLocation();
  const [module, setModule] = useState("");
  const navigate = useNavigate();
  const { contractsFormViewId, contractsViewId,contractsEquipmentViewId,contractsServiceViewId,contractsInvoiceViewId } = useParams();

  let searchList = [
    { value: "all", label: "All" },
    { value: "services", label: "Services" },
    { value: "products", label: "Products" },
  ];


  const from = location.state?.from || -1; 

  console.log("from",from);
  
  const [screenSize, setScreenSize] = useState({
    width: window.innerWidth,
  });

  useEffect(() => {
    const handleResize = () => {
      setScreenSize({
        width: window.innerWidth,
      });
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  useEffect(() => {
    if (pathname == `/client-management/contracts/view/${contractsViewId}`) {
      setModule("Details");
    }
    //  else if (
    //   pathname == `/client-management/contracts/form/${contractsViewId}`
    // ) {
    //   setModule("Forms");
    // }
    else if (
        pathname == `/client-management/contracts/inspection/${contractsViewId}`
      ) {
        setModule("Inspection");
      }else if (
        pathname == `/client-management/contracts/equip/${contractsViewId}`
      ) {
        setModule("Equipments");
      }else if (
        pathname == `/client-management/contracts/service/${contractsViewId}`
      ) {
        setModule("Service");
      }else if (
        pathname == `/client-management/contracts/invoice/${contractsViewId}`
      ) {
        setModule("Invoice");
      }
      
  }, [pathname]);

  let LinkItem = [
    {
      label: "Details",
      link: `/client-management/contracts/view/${contractsViewId}`,
      access: GetAccess(),
    },
    // {
    //   label: "Forms",

    //   link: `/client-management/contracts/form/${contractsViewId}`,
    //   access: GetAccess(),
    // },
    {
        label: "Inspection",
  
        link: `/client-management/contracts/inspection/${contractsViewId}`,
        access: GetAccess(),
      },
    {
        label: "Equipments",
  
        link: `/client-management/contracts/equip/${contractsViewId}`,
        access: GetAccess(),
      },
      {
        label: "Service",
  
        link: `/client-management/contracts/service/${contractsViewId}`,
        access: GetAccess(),
      },
      {
        label: "Invoice",
  
        link: `/client-management/contracts/invoice/${contractsViewId}`,
        access: GetAccess(),
      },
  ];

  

  return (
    <div className=" w-full  h-full py-2 px-4 md:overflow-hidden">
      <div className="md:flex justify-between w-full ">
        <Breadcrumb
                  items={[
                    // { name: "Client-Management" },
                    {
                      name: "Contracts",
                      link:"/client-management/contracts"

                     
                    },
        
                    { name: module },
                  ]}
                />
<div className="flex gap-2">
{newfilter && (
    <>
                <FilterButton label='Filter'  handleClick={()=>{setFilterOpen(true);setSearchQuery("");}} />
                {isFilter&& <ClearFilterButton label='Clear'  handleClick={ClearFilter} />} </>)}
<div className=" flex justify-end items-center gap-3 ">
          <div className=" flex gap-2">
            <Link
              to={`/client-management/contracts`}
              state={{
                currentPage: pageIndex,
                searchQuery: searchQuery != "" ? searchQuery : "",
              }}
            >
              <BackButton  />
            </Link>
            {/* {EditAccess && (
              <Link
                to={`/client-management/contracts/edit/${contractsViewId}`}
                state={{
                  data: data,
                  from: `/client-management/contracts/view/${contractsViewId}`,
                }}
              >
                <EditButton height="8" />
              </Link>
            )} */}
          </div>
        </div>
        </div>


      </div>

      <div className="w-full overflow-x-auto whitespace-nowrap scrollbar-hide">
  <div className="inline-flex items-center gap-x-1">
    {LinkItem && LinkItem.map((item, i) => {
      const isActive = item?.link === pathname;
      
      return (
        <React.Fragment key={item?.link || i}>
          {item.access && (
            <Link
              to={item?.link}
              className={`px-4 py-1 rounded-t-md text-xs 2xl:text-sm font-medium mt-0.5 inline-block
                ${isActive 
                  ? "bg-baseColor-primary text-white" 
                  : "bg-white text-baseColor-primary border-b-2 border-baseColor-primary"
                }`}
            >
              {item?.label || ""}
            </Link>
          )}
        </React.Fragment>
      );
    })}
  </div>
</div>


        

      <div className=" w-full h-[calc(100vh-165px)]  ">{children}</div>
    </div>
  );
};

export default ContractLayout;
